import './src/com-throttle.js';

import { COMThrottleBehavior } from './src/com-throttle.js';
export { COMThrottleBehavior };